import React, { Component } from 'react';
import { Singleton } from '../../../js/Singleton';
import { connectedIntegration, connectingIntegration, disconnectedIntegration, notFoundIntegration } from '../../../Images/Images';
import { STATES_INTEGRATION } from '../../../constants'

export default class IntegrationConnectWindow extends Component {
  constructor(props) {
    super(props);
    this.language = new Singleton();
    this.currentImage = {
      [STATES_INTEGRATION.connected]: connectedIntegration,
      [STATES_INTEGRATION.connecting]: connectingIntegration,
      [STATES_INTEGRATION.disconnecting]: disconnectedIntegration,
      [STATES_INTEGRATION.notFound]: notFoundIntegration,
    }
    this.buttonTitle = {
      [STATES_INTEGRATION.connected]: this.language.getText("GUIIntegrationconnected"),
      [STATES_INTEGRATION.connecting]: this.language.getText("GUIIntegrationconnecting"),
      [STATES_INTEGRATION.disconnecting]: this.language.getText("GUIIntegrationdisconnected"),
      [STATES_INTEGRATION.notFound]: this.language.getText("GUIIntegrationfail"),
    }
  }
  render() {
    return (
      <div className={"connectWindowIntegration " + this.props.stateIntegration}>
        <div className="circle1"></div>
        <div className="circle2"></div>
        <img alt={"icon"} className="iconIntegrationConnect" src={this.currentImage[this.props.stateIntegration]}></img>
        <p className="stateIntegrationConnect">{this.buttonTitle[this.props.stateIntegration]}</p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/workSpace/Others/IntegrationConnectWindow.jsx